<template>
  <header v-view class="main_menu">
    <div class="mobile-toolbar" :class="mobile_menu_open? 'active': ''">
      <button class="menu_toggle" :class="mobile_menu_open? 'active': ''" @click="menu_toggle()">
        <span />
      </button>
      <button
        v-if="show_search"
        class="search_icon"
        :class="mobile_menu_open? 'active': ''"
        @click="goToSearch()"
      >
        <span class="fa fa-search text-white" />
      </button>
    </div>
    <div v-view class="container clearfix">
      <div class="mobile_donateBtn float-right">
        <router-link to="/donate/form">
          <img :src="getAssetLink('/assets/media/theme/btn_home_donate.png')" width="120" />
        </router-link>
      </div>
      <div class="brand d-inline-block">
        <router-link to="/">
          <img class="logo" alt="OSC logo" :src="getAssetLink('/assets/media/theme/logo.png')" />
        </router-link>
      </div>
      <div class="donateSum_container">
        <div class="main-search-container">
          <SearchBox v-if="show_search && !mobile_view" ontop="1" />
          <div class="lang_selector">
            <template v-for="(lang, i) in languages">
              <span v-if="i>0" :key="`lang-sp${i}`">|</span>
              <b-button
                :key="`lang-${ lang.locale }`"
                variant="link"
                class="lang_selector_btn"
                :class="$i18n.locale === lang.locale? 'active': ''"
                @click="switchLanguage(lang.locale)"
              >{{ lang.name }}</b-button>
            </template>
          </div>
          <div class="social_block">
            <ul class="linkList list-unstyled m-0">
              <li>
                <ul class="list-unstyled m-0">
                  <li>
                    <template v-for="item in social_links">
                      <a
                        v-if="item.url"
                        :id="`social_link_${item.key}`"
                        :key="item.key"
                        target="_blank"
                        :href="item.url"
                        class="social_icon"
                      >
                        <img :src="item.image" border="0" />
                      </a>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <DonateBtn v-view.once class="animated fadeInRight" />
      </div>
    </div>
    <div class="main_menu_nav clearfix">
      <div class="container p-0">
        <nav class="nav" :class="mobile_menu_open? 'active': ''" @click="menu_toggle()">
          <ul v-if="items" id="topNav" class="list-unstyled m-0">
            <li
              v-for="(item, index) in items"
              :key="`nav-item-${index}`"
              :class="mobile_submenu_open === index? 'active': ''"
            >
              <CustomLink :url="item.url">{{ item.name }}</CustomLink>
              <span
                v-if="item.sub_menus"
                class="submenu_toggle"
                :class="mobile_submenu_open === index? 'active': ''"
                @click="submenu_toggle(index, $event)"
              />
              <ul v-if="item.sub_menus" class="list-unstyled m-0">
                <li
                  v-for="(child, i) in item.sub_menus"
                  :id="`nav-child-item-${i}`"
                  :key="`nav-child-item-${i}`"
                >
                  <CustomLink :url="child.url">{{ child.name }}</CustomLink>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import DonateBtn from "@/components/DonateBtn.vue";
import CustomLink from "@/components/CustomLink";
import SearchBox from "@/components/SearchBox";
// import _ from "lodash";

export default {
  name: "Header",
  components: {
    DonateBtn,
    CustomLink,
    SearchBox
  },
  data: function() {
    return {
      mobile_view: false,
      mobile_menu_open: false,
      mobile_submenu_open: null,
      show_search: true,
      items: [],
      languages: [
        {
          name: "English",
          locale: "en"
        },
        {
          name: "中文",
          locale: "zh"
        }
      ],
      social_links: [
        {
          key: "FB",
          url: localStorage.getItem("social_facebook"),
          image: this.getAssetLink("/assets/media/theme/icon/icon_FB.svg")
        },
        {
          key: "IG",
          url: localStorage.getItem("social_instagram"),
          image: this.getAssetLink(
            "/assets/media/theme/icon/icon_instagram.svg"
          )
        },
        {
          key: "YT",
          url: localStorage.getItem("social_youtube"),
          image: this.getAssetLink("/assets/media/theme/icon/icon_youtube.svg")
        }
      ]
    };
  },
  mounted: function() {
    this.init();
    localStorage.locale = this.$i18n.locale;
  },
  methods: {
    init() {
      this.$http
        .get("menu")
        .then(response => {
          if (response.data.data) {
            localStorage.setItem("menu", JSON.stringify(response.data.data));
          }
        })
        .finally(() => {
          // Retrieve the menu items from storage
          var items = localStorage.getItem("menu");
          if (items) {
            this.items = JSON.parse(items);
          }
        });
    },
    menu_toggle() {
      this.mobile_menu_open = !this.mobile_menu_open;
    },
    goToSearch() {
      this.mobile_menu_open = false;
      this.$router.push("/search");
    },
    submenu_toggle(index, event) {
      event.stopPropagation();
      if (this.mobile_submenu_open == index) {
        this.mobile_submenu_open = null;
      } else {
        this.mobile_submenu_open = index;
      }
    },
    switchLanguage(locale = null) {
      if (locale != null) this.$i18n.locale = locale;
      localStorage.locale = this.$i18n.locale;
      new Promise(resolve => this.$emit("refresh", resolve)).then(success => {
        if (success) {
          this.init();
        }
      });
    }
  }
};
</script>